export default "__VITE_ASSET__CqWauBMZ__"